import { Permutive } from '../../../../services/analytics/tags/permutive'
import { AnalyticsEvent } from '../../event'
export class PermutiveProvider extends AnalyticsEvent {

    private data: any
    private commonAttrs: string[] = []

    public constructor(data: any, type: string, value: string, action: string, element?: Element) {
        super(type, value, action, element)
        this.data = data
    }

    /**
     * Handle event
     */
    public handle(): void {

        /**
         * Event Handler: updates the attributes list and sends it to permutive
         * @var data will be different for each event
         *
         */
        const permutive = new Permutive()
        const dataAttrs = this.getProviderAttributesList('permutive', this.commonAttrs)
        const customData = this.getProviderCustomData('permutive')
        const eventData = permutive.getEventData(this.metaProperties, dataAttrs, this.data, customData)

        if (this.action !== 'page-load' && this.type) {

            // send permutive event with attributes
            permutive.sendEvent(this.type, eventData)
        }
    }
}
